import styled from "styled-components";
import { VerificationForm } from "./components/verification-form";
import { VerificationFormDetail } from "./components/verification-detail-form";
import { VerificationImportForm } from "./components/verification-import-form";
import { useChildIntergrationSettingInfo } from "./hooks/useChildIntergrationSettingInfo";
import { Button } from "@renderbus/ui";
import { verificationSettingBtnDeploy } from "./config/setting-form";
import { VerificationSteps } from "./components/verification-steps";
import { VerificationStepsEnum } from "./constant";
import { FormInstance } from "antd";
import { useEffect } from "react";
import { Form } from "antd";
import { useDingTalkSubAccountStore } from "../../store/dingtalk-subaccount-store";

export function ChildIntegrationSetting() {
  const { setCurrentBtnStatus } = useDingTalkSubAccountStore();
  const { verificationForm, currentSteps, verificationBackForm, currentStepBtnLoading, currentStepForm, getCurrentStepsNext, getCurrentStepsPre } = useChildIntergrationSettingInfo();
  return (
    <ChildIntegrationSettingContainer>
      <VerificationSteps currentStep={currentSteps} />
      {
        currentSteps === VerificationStepsEnum.STEP1 && <VerificationForm form={verificationForm}></VerificationForm>
      }
      {
        currentSteps === VerificationStepsEnum.STEP2 && <VerificationImportForm form={verificationBackForm} handleCheckValidator={(value)=> setCurrentBtnStatus(value)}></VerificationImportForm>
      }
      {
        currentSteps === VerificationStepsEnum.STEP3 && <VerificationFormDetail form={verificationBackForm}></VerificationFormDetail>
      }
      <IntegrationSettingFooter>
        <Button onClick={() => getCurrentStepsPre()} disabled={currentSteps === VerificationStepsEnum.STEP3 && currentStepBtnLoading[currentSteps]}>{verificationSettingBtnDeploy.get(currentSteps)?.preBtn}</Button>
        <SubmitButton currentStep={currentSteps} loadingStatus={currentStepBtnLoading[currentSteps]} 
          text={verificationSettingBtnDeploy.get(currentSteps)?.nextBtn || ''} 
          form={currentStepForm[currentSteps] || verificationForm} 
          handleClick={() => getCurrentStepsNext()} />
      </IntegrationSettingFooter>
    </ChildIntegrationSettingContainer>
  );
}

const SubmitButton = ({
  currentStep,
  form,
  text,
  handleClick,
  loadingStatus,
}: {
  currentStep: VerificationStepsEnum;
  form: FormInstance;
  text: string;
  handleClick: () => void;
  loadingStatus?: boolean;
}) => {
  const { currentBtnStatus, setCurrentBtnStatus } =
    useDingTalkSubAccountStore();

  const values = Form.useWatch([], form);
  useEffect(() => {
    if (currentStep !== VerificationStepsEnum.STEP1) return;
    form.validateFields().then(
      () => {
        setCurrentBtnStatus(true);
      },
      () => {
        setCurrentBtnStatus(false);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  return (
    <SubmitBtnContainer
      type="primary"
      disabled={currentStep === VerificationStepsEnum.STEP3 ? false : !currentBtnStatus}
      onClick={() => handleClick()}
      loading={loadingStatus}
    >
      {text}
    </SubmitBtnContainer>
  );
};

const ChildIntegrationSettingContainer = styled.div`
  display: flex;
  flex-direction: column;
  .integration-item-title {
    background: #1c1c21;
    line-height: 22px;
    padding: 10px 0;
    text-align: center;
    color: #d4d4d4;
    margin-bottom: 10px;
  }
`;

const IntegrationSettingFooter = styled.div`
  border-top: 1px solid #43454d;
  height: 64px;
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SubmitBtnContainer = styled(Button)`
  margin-left: 20px;
  &:disabled,
  &:disabled:hover {
    color: #ffffff !important;
    background: #75c9a2 !important;
  }
`
